import { Service, signal } from '@angular/core';
import { environment } from '../../../environments/environments';

@Service()
export class AppConfig {
    public readonly apiUrl = signal<string>(environment.apiUrl);
}
